import React from 'react';
import { IonModal, IonContent } from '@ionic/react';
import Button from '../../../../components/atoms/button';
import { createBrowserHistory } from 'history';
import './SignInModal.css';

interface SignInModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const SignInModal: React.FC<SignInModalProps> = ({
  isOpen,
  onClose
}) => {
  const browserHistory = createBrowserHistory();

  const handleSignIn = () => {
    browserHistory.push("/app/signIn");
    browserHistory.go(0);
    onClose();
  };

  return (
    <IonModal
      isOpen={isOpen}
      initialBreakpoint={0.5}
      breakpoints={[1, 1, 1, 1]}
      onWillDismiss={onClose}
      trigger="open-custom-dialog"
    >
      <IonContent>
        <div className="sign-in-modal-content w-full h-full pt-4 flex flex-col justify-start items-center">
          <p className="font-bold text-primaryColor100 text-2xl">
            يرجى تسجيل الدخول لتتمكن من الاضافة
          </p>

          <div className="w-full mt-4 px-4 grid grid-cols-2 gap-4">
            <Button
              theme={"primary"}
              text={"موافق"}
              size={"big"}
              onClick={handleSignIn}
            />
            <Button
              theme={"danger"}
              text={"إغلاق"}
              size={"big"}
              onClick={onClose}
            />
          </div>
        </div>
      </IonContent>
    </IonModal>
  );
};

export default SignInModal;
